import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { errorTypes } from "@/utility/validation"
import { Button } from "@/components/ui/button"
import Card from "@/components/common/Card"
import { ThrowError } from "@/api/callApi"
import { RoutesLink } from "@/utility/RouteLinks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import Layout from "@/components/layout/Layout"
import MainHeading from "@/components/common/MainHeading"
import FormField from "@/components/common/FormField"
import { showToastNotification } from "@/utility/helper"
import type { campus } from "@/interface/campus.interface"
import { CampusService } from "@/services/Campus/CampusService"
import { SiteService } from "@/services/Site/SiteServive"
import SearchSelect from "@/components/common/SearchSelect"

const AddCampus: React.FC = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm<campus>();
    const [sites, setSites] = useState<{ value: string; label: string }[]>([]);
    // const [menuBars, setMenuBar] = useState<{ value: string; label: string }[]>([]);

    const getSite = async () => {
        try {
            const response = await SiteService.getSite();
            if (response?.status) {
                const formatted = (response?.data?.site || []).map((item) => ({
                    value: item?.id || "",
                    label: item?.name || ""
                }));
                setSites(formatted);
            }
        } catch (error) {
            ThrowError(error);
        }
    }

    const getCampusById = async () => {
        if (!id) return;
        setIsLoading(true);
        try {
            const response = await CampusService.getCampusById(id);
            if (response?.status) {
                setValue("name", response?.data?.name);
                setValue("siteId", response?.data?.siteId);
                setValue("address", response?.data?.address);
                setValue("city", response?.data?.city);
                setValue("state", response?.data?.state);
                setValue("pinCode", response?.data?.pinCode);
                setValue("status", response?.data?.status);
                setValue("code", response?.data?.code);
            }
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getSite();
        if (id) {
            getCampusById();
        }
    }, []);

    const onSubmit = async (data: campus) => {
        console.log(data);
        try {
            setIsLoading(true);
            const payload = {
                name: data.name,
                siteId: data.siteId,
                address: data.address,
                city: data.city,
                state: data.state,
                pinCode: data.pinCode,
                status: data.status,
                code: data.code,

            }
            if (id) {
                const response = await CampusService.updateCampus(id, payload);
                if (response?.status) {
                    showToastNotification("success", response?.message);
                    navigate(RoutesLink.superAdminCampus);
                }
            } else {
                const response = await CampusService.createCampus(payload);
                if (response?.status) {
                    showToastNotification("success", response?.message);
                    navigate(RoutesLink.superAdminCampus);
                }
            }
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading
                    title={id ? "Edit Designation" : "Add Designation"}
                    isBackButtonVisible
                    onClick={() => navigate(-1)}
                />
                <Card className='overflow-visible'>
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormField
                                {...register("name", { ...errorTypes.required('Name') })}
                                type="text"
                                label="Name"
                                placeholder="Enter Designation Name"
                                error={errors.name?.message}
                            />
                            <SearchSelect
                                label="Site"
                                required
                                placeholder="Select Site"
                                options={sites}
                                value={watch("siteId")}
                                onChange={(val) => setValue("siteId", val)}
                                error={errors.siteId?.message}
                            />
                            {/* <FormField
                                {...register("isParent", { ...errorTypes.required("Is Parent") })}
                                type="text"
                                label="Is Parent"
                            // error={errors.isParent?.message}
                            /> */}
                            {/* <MultiSelectSearch
                                label="Menu Access"
                                required
                                placeholder="Select Menu Access"
                                options={menuBars}
                                value={watch("menuBar")?.keyNames || []}
                                onChange={(val) => setValue("menuBar", { keyNames: val })}
                                error={errors.menuBar?.message}

                            /> */}
                            <FormField
                                {...register("address", { ...errorTypes.required("Address") })}
                                type="text"
                                label="Address"
                                placeholder="Enter Address"
                                error={errors.address?.message}
                            />
                            <FormField
                                {...register("city", { ...errorTypes.required("City") })}
                                type="text"
                                label="City"
                                placeholder="Enter City"
                                error={errors.city?.message}
                            />

                            <FormField
                                {...register("state", { ...errorTypes.required("State") })}
                                type="text"
                                label="State"
                                placeholder="Enter State"
                                error={errors.state?.message}
                            />

                            <FormField
                                {...register("pinCode", { ...errorTypes.required("Pin Code") })}
                                type="text"
                                label="Pin Code"
                                placeholder="Enter Pin Code"
                                error={errors.pinCode?.message}
                            />

                            <FormField
                                {...register("status", { ...errorTypes.required("Status") })}
                                type="select"
                                value={String(watch("status") ?? "")}
                                options={[
                                    { value: "select", label: "Select Status" },
                                    { value: "true", label: "Active" },
                                    { value: "false", label: "Inactive" },
                                ]}
                                label="Is Active"
                                error={errors.status?.message}
                            />

                        </div>
                        <div className="flex justify-end">
                            <Button disabled={isLoading} type="submit">{isLoading ? "Submitting..." : "Submit"}</Button>
                        </div>
                    </form>
                </Card>
            </div>
        </Layout>
    )
}

export default AddCampus